import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["as", "active", "block", "children", "classes", "color", "disabled", "loaderProps", "loading", "onClick", "primary", "radius", "round", "size", "style", "theme", "type", "namespace"];
import React, { Children, forwardRef, useCallback, useMemo } from 'react';
import classNames from 'classnames/bind';
import { getMethodsForTestId } from "../utils/getMethodsForTestId";
import noop from "../utils/noop";
import { isString } from "../utils/type";
import Loader from '../Loader';
import { sizes, types } from './constants';
import { getStyles } from './utils';
import styles from './Button.css';
var cx = classNames.bind(styles);
var defaultClasses = {};
export var Button = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _cx;

  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'button' : _ref$as,
      active = _ref.active,
      _ref$block = _ref.block,
      block = _ref$block === void 0 ? false : _ref$block,
      children = _ref.children,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultClasses : _ref$classes,
      color = _ref.color,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$loaderProps = _ref.loaderProps,
      loaderProps = _ref$loaderProps === void 0 ? {} : _ref$loaderProps,
      loading = _ref.loading,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? noop : _ref$onClick,
      primary = _ref.primary,
      radius = _ref.radius,
      round = _ref.round,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? sizes.medium : _ref$size,
      styleProp = _ref.style,
      theme = _ref.theme,
      type = _ref.type,
      namespace = _ref.namespace,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'button'),
      getTestId = _getMethodsForTestId.getTestId;

  var content = useMemo(function () {
    return Children.map(children, function (child) {
      return isString(child) ? /*#__PURE__*/React.createElement("span", null, child) : child;
    });
  }, [children]);
  var style = useMemo(function () {
    return getStyles({
      radius: radius,
      round: round,
      style: styleProp
    });
  }, [round, radius, styleProp]);
  var handleClick = useCallback(function () {
    if (document && document.activeElement) {
      document.activeElement.blur();
    }

    return onClick.apply(void 0, arguments);
  }, [onClick]);
  return /*#__PURE__*/React.createElement(Component, _extends({}, rest, getTestId(), {
    className: cx('root', (_cx = {}, _defineProperty(_cx, "theme_".concat(theme), theme), _defineProperty(_cx, "size_".concat(size), size), _defineProperty(_cx, "color_".concat(color), color), _defineProperty(_cx, "block", block), _defineProperty(_cx, "disabled", disabled), _defineProperty(_cx, "loading", loading), _defineProperty(_cx, "primary", primary), _defineProperty(_cx, "round", round), _defineProperty(_cx, "active", active), _cx), classes.root),
    disabled: disabled,
    onClick: handleClick,
    ref: ref,
    style: style,
    type: !type && Component === 'button' ? types.button : type
  }), loading && /*#__PURE__*/React.createElement("div", {
    className: cx('loader', classes.loader)
  }, /*#__PURE__*/React.createElement(Loader, _extends({
    view: "flow",
    color: theme === 'secondary' ? 'N60' : undefined
  }, loaderProps))), /*#__PURE__*/React.createElement("span", {
    className: cx('content', classes.content)
  }, content));
});
export default Button;